export default __webpack_public_path__ + "static/media/aotu2.1af7aeb5.jpg";